import React from "react"
import { Container, Row } from "./Styled"
import ListEntry from "../../../../../components/Order/Ui/ListEntry"
import { Order } from "lib/types/generated/graphql-types"
import Dinero from "dinero.js"
import DineroFactory from "dinero.js"
import TaxGroup from "./TaxGroup"

type PaymentTax = {
  id: string
  taxPercentage: number
  taxPercentageDecimals: number
}

type Props = {
  order: Order
}

const Vat = ({ order }: Props) => {

  const paymentTax : PaymentTax[] = order.orderLines?.map((ol) => ({
    id: ol.taxGroupId,
    taxPercentage: ol.taxPercentage,
    taxPercentageDecimals: ol.taxPercentageDecimals
  })).filter((tax, index, self) =>
    index === self.findIndex(t => t.id === tax.id)
  ) ?? []

  return (
    <Container>
      <Row $columns={"1fr 1fr 1fr"}>
        <ListEntry
          label={"Total tax"}
          value={Dinero({
            amount: order.totals.taxTotal,
            currency: order.currencyCode as DineroFactory.Currency
          }).toFormat()}
        />
        {paymentTax?.map((tax) => <TaxGroup paymentTax={tax} />)}
      </Row>
    </Container>
  )
}

export default Vat
